module.exports = __webpack_public_path__ + "img/engineering.57ed502a.svg";